import "./Puppies.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import PuppyListings from "./sections/PuppyListings";
import FaleComEspecialistas from "./sections/FaleComEspecialistas";
import MomentsWeveCaptured from "./sections/MomentsWeveCaptured";
import FeaturedCollection from "./sections/FeaturedCollection";
import Litters from "./sections/Litters";
import Footer from "@/reusable_sections/Footer";
export default function PuppiesPage() {
  return <div>
      <Header />
      <Hero />
      <PuppyListings />
      <MomentsWeveCaptured />
      <FaleComEspecialistas />
      <FeaturedCollection />
      <Litters />
      <Footer />
    </div>;
}